import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from 'App/shadcn/lib/utils';
import T from 'Components/Helpers/translate';

type Props = {
	status?: string;
	avatarUrl?: string | null;
	avatarColor?: string;
	assistantName?: string;
	/** Use inside already-centred columns (e.g. RunSection) so the bar doesn't
	 *  double-centre and shift the avatar away from the final message's avatar. */
	inline?: boolean;
};

const brandInitials = (name?: string): string => {
	const words = (name || '').trim().split(/\s+/).filter(Boolean);
	if (words.length === 0) return '';
	if (words.length === 1) return words[0].charAt(0).toUpperCase();
	return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

const LoadingBar = ({ status, avatarUrl, avatarColor, assistantName, inline }: Props) => {
	const [avatarError, setAvatarError] = useState(false);
	const initials = brandInitials(assistantName);
	return (
		<div
			className={cn('pr-thinking', inline && 'pr-thinking--inline')}
			// `.ws-chat-body .pr-thinking` has higher CSS specificity than the
			// `.pr-thinking--inline` reset, so inline padding wins instead.
			style={inline ? { paddingBottom: 16, paddingLeft: 0, paddingRight: 0 } : { paddingBottom: 16 }}
		>
			<div className="pr-avatar-sm" style={!avatarUrl && avatarColor ? { background: avatarColor } : undefined}>
				{avatarUrl && !avatarError ? (
					<img src={avatarUrl} alt="" onError={() => setAvatarError(true)} />
				) : initials ? (
					initials
				) : (
					<Sparkles className="h-3.5 w-3.5" />
				)}
			</div>
			<div className="pr-thinking-body">
				<div className="pr-dots">
					<span />
					<span />
					<span />
				</div>
				<div className="pr-tool-status">
					{status ? (
						<>
							<span className="pr-spin" />
							{status}
						</>
					) : (
						T('assistant.thinking')
					)}
				</div>
			</div>
		</div>
	);
};

export default LoadingBar;
